module.exports = __webpack_public_path__ + "images/duin-d7d7adcbf02e2e5534dfe17ec49e9e26.jpg";